import { render, staticRenderFns } from "./configPiece.vue?vue&type=template&id=41fe40af&scoped=true"
import script from "./configPiece.vue?vue&type=script&lang=js"
export * from "./configPiece.vue?vue&type=script&lang=js"
import style0 from "./configPiece.vue?vue&type=style&index=0&id=41fe40af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fe40af",
  null
  
)

export default component.exports